import { createRoot } from 'react-dom/client';
import { MapWithHotspots } from '../../components/MapWithHotspots';

const container = document.getElementById('map-container');
if (container) {
    const root = createRoot(container);
    root.render(<MapWithHotspots />);
}
